import { Alert, Button, Flex } from 'antd'
import type { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onRetry?: () => void
  /** Overrides default `ui.loadError` */
  messageText?: string
  className?: string
  style?: CSSProperties
}

export const QueryErrorAlert = ({
  onRetry,
  messageText,
  className,
  style
}: Props) => {
  const { t } = useTranslation()

  return (
    <Alert
      className={className}
      style={{ width: '100%', ...style }}
      type="error"
      showIcon
      role="alert"
      title={messageText ?? t('ui.loadError')}
      description={
        <Flex vertical gap={8} style={{ marginTop: 4 }}>
          <span>{t('ui.loadErrorDescription')}</span>
          {onRetry ? (
            <div>
              <Button size="small" type="primary" onClick={onRetry}>
                {t('ui.retry')}
              </Button>
            </div>
          ) : null}
        </Flex>
      }
    />
  )
}
